export default "__VITE_ASSET__Clg$NMo7__"